import React, { memo, SVGProps } from 'react'

export const Bold = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.6288 5.67361H8.92801C8.13313 5.67361 7.48801 6.31873 7.48801 7.11361V16.8864C7.48801 17.6813 8.13313 18.3264 8.92801 18.3264H12.6288C14.7696 18.3264 16.512 16.585 16.512 14.4432C16.512 13.513 16.1693 12.6691 15.6221 12C16.1693 11.3309 16.512 10.4871 16.512 9.55681C16.512 7.41601 14.7706 5.67361 12.6288 5.67361ZM10.368 8.55361H12.6288C13.1818 8.55361 13.632 9.00385 13.632 9.55681C13.632 10.1098 13.1818 10.56 12.6288 10.56H10.368V8.55361ZM12.6288 15.4464H10.368V13.44H12.6288C13.1818 13.44 13.632 13.8903 13.632 14.4432C13.632 14.9962 13.1818 15.4464 12.6288 15.4464Z"
      fill="currentColor"
    />
  </svg>
))
